import { rankingItems } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-trophy-line"></i>
              人气榜单
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              韩漫热度排行榜
            </h2>
            <p className="text-foreground-500 text-sm mt-2">
              实时更新 · 热门连载 · 读者最爱
            </p>
          </div>
          <div className="flex gap-2 mt-3 md:mt-0">
            <span className="px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium cursor-pointer">热度榜</span>
            <span className="px-3 py-1.5 rounded-full text-foreground-500 text-xs font-medium cursor-pointer hover:bg-background-200/50 transition-colors">新作榜</span>
            <span className="px-3 py-1.5 rounded-full text-foreground-500 text-xs font-medium cursor-pointer hover:bg-background-200/50 transition-colors">完结榜</span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {rankingItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  width="200"
                  height="280"
                />
                <div className="absolute top-0 left-0 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-primary-500 text-background-50 font-bold text-sm font-heading rounded-br-lg">
                  {item.rank}
                </div>
                {item.trend === 'up' && (
                  <div className="absolute top-0 right-0 w-8 h-8 flex items-center justify-center">
                    <i className="ri-arrow-up-line text-accent-500 text-lg"></i>
                  </div>
                )}
              </div>
              <div className="p-3">
                <h3 className="text-sm font-semibold text-foreground-900 mb-0.5 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-[11px] text-foreground-500 line-clamp-1 mb-1">
                  {item.genre}
                </p>
                <div className="flex items-center gap-1 text-[11px] text-foreground-400">
                  <i className="ri-eye-line text-[10px]"></i>
                  <span>{item.views}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}